module.exports = __webpack_public_path__ + "static/media/brego3594.02af9162.jpg";